module.exports = __webpack_public_path__ + "static/media/contact_02.10a467ce.jpg";